import { createContext } from "react";
export const Todos = createContext([]);
